const clean = value => {
  return typeof value === 'string' ? value.trim()
    .replace('$', '')
    .replace('%', '')
    .replace('.00', '')
    .replace(',', '') : value;
};

export default class Appraisal {
  constructor(totalAmountAwarded, totalNPVAtEndorsementDate, appraisalsOperations) {
    this.totalAmountAwarded = Number(clean(totalAmountAwarded));
    this.totalNPVAtEndorsementDate = Number(clean(totalNPVAtEndorsementDate));
    this.appraisalsOperations = appraisalsOperations;
  }

  setInvestorName(investorName) {
    this.investorName = investorName;
    return this;
  }

  setInvestorId(investorId) {
    this.investorId = investorId;
    return this;
  }

  setSalesType(salesType) {
    this.salesType = salesType;
    return this;
  }

  setSalesDate(salesDate) {
    this.salesDate = salesDate;
    return this;
  }

  setTotalOperations(totalOperations) {
    this.totalOperations = totalOperations;
    return this;
  }
}
